import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule, DecimalPipe } from "@angular/common";
import { RouterModule } from "@angular/router";
import { DodoComponentsModule } from "../../_libs/dodo-components/dodo-components.module";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AddressService } from "./services/address.service";
import { ConfigService } from "./services/config.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../_libs/material-module/material.module";
import { DodoMatComponentsModule } from "../../_libs/dodo-mat-components/dodo-mat-components.module";
import { TealiumModule } from "../../tealium/tealium.module";
import { IntegerDigitsPipe } from "./pipes/integer-digits.pipe";
import { FractionDigitsPipe } from "./pipes/fraction-digits.pipe";
import { MessagePageLayoutComponent } from "./components/message-page-layout/message-page-layout.component";
import { AppErrorGuard } from "./services/app-error.guard";
import { DodoManualAddressEntryComponent } from "./components/manual-address-entry-form/manual-address-entry.component";
import { RequestCallbackDialogComponent } from "./components/request-callback-dialog/request-callback-dialog.component";
import { NavbarToggleService } from "./services/navbar-toggle.service";
import { ErrorNotifierComponent } from "./components/error-notifier/error-notifier.component";
import { HeaderToggleService } from "./services/header-toggle.service";
import { DebugService } from "./services/debug.service";
import { InternationalRatesDialogComponent } from "./components/international-rates-dialog/international-rates-dialog.component";
import { QueryParamResolver } from "./services/query-param.resolver";
import { InfoDialogLayoutComponent } from "./components/info-dialog-layout/info-dialog-layout.component";
import { PriceFormatPipe } from "./pipes/price-format.pipe";
import { DealerDisplayComponent } from "./components/dealer-display/dealer-display.component";
import { TryCatchMaterialFormsModule } from "@dodo/material-forms";
import { ErrorDialogComponent } from "./components/error-dialog/error-dialog.component";
import { ShoppingCartModule } from "app/shopping-cart/shopping-cart.module";
import { DodoDirectives } from "@dodo/directives/directives.module";
import { ExternalDocumentLinkComponent } from "./components/external-document-link/external-document-link.component";
import { GenericService } from "./services/generic.service";
import { SimkitDialogComponent } from "./components/simkit-dialog/simkit-dialog.component";
import { PopupMessageDialogComponent } from "./components/popup-message-dialog/popup-message-dialog.component";
import { SelectedAddressComponent } from "./components/selected-address/selected-address.component";
import { WhatsNextComponent } from "./components/whats-next/whats-next.component";
import { FormTabsComponent } from "./components/form-tabs/form-tabs.component";
import { RequestCallbackDialogLayoutComponent } from "./components/request-callback-dialog-layout/request-callback-dialog-layout";
import { SummaryDetailsHeaderComponent } from "./components/summary-details-header/summary-details-header.component";
import { SummaryFigureHeaderComponent } from "./components/summary-figure-header/summary-figure-header.component";
import { MuleHealthService } from "./services/mule-health.service";
import { MuleGetPlanService } from "./services/mule-get-plan.service";
import { MuleCreateQuoteService } from "./services/mule-create-quote.service";
import { MuleHotlistCheckService } from "./services/mule-hotlist-check.service";
import { ManualAddressModule } from "@dodo/manual-address/manual-address.module";
import { BaseHeaderComponent } from "./components/base-header/base-header.component";
import { IdVerificationFailureDialogComponent } from './components/id-verification-failure-dailog/id-verification-failure-dialog.component';

const components = [
	MessagePageLayoutComponent,
	DodoManualAddressEntryComponent,
	RequestCallbackDialogComponent,
	InternationalRatesDialogComponent,
	ErrorNotifierComponent,
	InfoDialogLayoutComponent,
	IntegerDigitsPipe,
	FractionDigitsPipe,
	PriceFormatPipe,
	DealerDisplayComponent,
	ErrorDialogComponent,
	ExternalDocumentLinkComponent,
	SimkitDialogComponent,
	IdVerificationFailureDialogComponent,
	PopupMessageDialogComponent,
	SelectedAddressComponent,
	WhatsNextComponent,
	FormTabsComponent,
	RequestCallbackDialogLayoutComponent,
	SummaryDetailsHeaderComponent,
	SummaryFigureHeaderComponent,
	BaseHeaderComponent,
];

const services = [
	ConfigService,
	AddressService,
	AppErrorGuard,
	NavbarToggleService,
	HeaderToggleService,
	DebugService,
	QueryParamResolver,
	GenericService,
	MuleHealthService,
	MuleGetPlanService,
	MuleCreateQuoteService,
	MuleHotlistCheckService,
];

@NgModule({ declarations: [...components, ErrorDialogComponent,
        // Previously in entryComponents:
        RequestCallbackDialogComponent,
        InternationalRatesDialogComponent,
        ErrorDialogComponent,
        SimkitDialogComponent,
		IdVerificationFailureDialogComponent,
        PopupMessageDialogComponent,
        RequestCallbackDialogLayoutComponent,
    ],
    exports: [...components], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DodoComponentsModule,
        ManualAddressModule,
        DodoMatComponentsModule,
        TealiumModule,
        TryCatchMaterialFormsModule,
        ShoppingCartModule,
        DodoDirectives], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppCoreModule {
	static forRoot(): ModuleWithProviders<AppCoreModule> {
		return {
			ngModule: AppCoreModule,
			providers: [...services, DecimalPipe, PriceFormatPipe],
		};
	}
}
